import { render, staticRenderFns } from "./New-user.vue?vue&type=template&id=286834cf&"
import script from "./New-user.vue?vue&type=script&lang=js&"
export * from "./New-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports